import { cn } from '@/lib/cn';

/**
 * "Online" means the backend saw telemetry within the last five minutes. The label
 * spells that out rather than leaving a bare green dot to be interpreted — on this
 * product, believing a device is live when it is not is the dangerous mistake.
 */
export function OnlineDot({ online, className }: { online: boolean; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span
        className={cn('size-2 rounded-full', online ? 'bg-ok' : 'bg-ink-muted')}
        aria-hidden
      />
      <span className={cn('text-[13px] font-medium', online ? 'text-ok' : 'text-ink-muted')}>
        {online ? 'Reporting' : 'No signal'}
      </span>
    </span>
  );
}
